module.exports = __webpack_public_path__ + "static/media/highendhouse.523c564c.png";